module.exports = __webpack_public_path__ + "img/partners.47886143.svg";